module.exports = __webpack_public_path__ + "static/media/4.d556aae0.jpg";